<template>
    <div style="margin-left:12.5%;margin-right:12.5%;background-color:#ffffff;border:1px solid #eeeeee;padding:20px;">
    <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/RC/tasks' }">{{ $route.meta.title }}</el-breadcrumb-item>
        <el-breadcrumb-item>{{ taks_name }}</el-breadcrumb-item>
    </el-breadcrumb>
    <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="名单设置" name="first">
            <user-mana :task_id="task_id" ref="user_mana"></user-mana>
        </el-tab-pane>
        <el-tab-pane label="离职倾向设置" name="second">
            <div style="width:100%;height:40px;margin-bottom:10px;">
                <div class="top_buttons" style="float:left;">
                    <el-button icon="el-icon-download" @click="download_behavior_template">下载模板</el-button>
                    <el-button icon="el-icon-document" type="primary" @click="import_behavior_template">导入行为</el-button>
                    <el-button icon="el-icon-document" type="warning" @click="export_behavior_report">下载报告</el-button>
                    <el-dialog title="上传文件" :visible.sync="dialogFormVisible_behavior" width="600px" :destroy-on-close="true" :close-on-click-modal="false">
                        <upload ref="upload_file" :getRCBehavior="getRCBehavior" :task_id="task_id"></upload>
                        <div style="margin-top:-10px;">
                            <el-button @click="dialogCancel_behavior">取 消</el-button>
                            <el-button type="primary" @click="uploadFile_behavior">立即上传</el-button>
                        </div>
                    </el-dialog>
                </div>
            </div>
            <behav-mana ref="behav_mana" :behavior_info="behavior_info"></behav-mana>
        </el-tab-pane>
        <el-tab-pane label="工作动机设置" name="third">
            <div style="width:100%;height:40px;margin-bottom:10px;">
                <div class="top_buttons" style="float:left;">
                    <el-button icon="el-icon-download" @click="download_motivation_template">下载模板</el-button>
                    <el-button icon="el-icon-document" type="primary" @click="import_motivation_template">导入动机</el-button>
                    <el-button icon="el-icon-document" type="warning" @click="export_motivation_report">下载报告</el-button>
                    <el-dialog title="上传文件" :visible.sync="dialogFormVisible_motivation" width="600px" :destroy-on-close="true" :close-on-click-modal="false">
                        <upload ref="upload_file" :getRCMotivation="getRCMotivation" :task_id="task_id"></upload>
                        <div style="margin-top:-10px;">
                            <el-button @click="dialogCancel_motivation">取 消</el-button>
                            <el-button type="primary" @click="uploadFile_motivation">立即上传</el-button>
                        </div>
                    </el-dialog>
                </div>
            </div>
            <motiv-mana 
            ref="motiv_mana"
            :task_id="task_id"
            ></motiv-mana>
        </el-tab-pane>
        <el-tab-pane label="激励资源设置" name="fourth">
            <div style="width:100%;height:40px;margin-bottom:10px;">
                <div class="top_buttons" style="float:left;">
                    <el-button icon="el-icon-download" @click="download_resource_template">下载模板</el-button>
                    <el-button icon="el-icon-document" type="primary" @click="import_resource_template">导入资源</el-button>
                    <el-button icon="el-icon-document" type="warning" @click="export_resource_report">下载资源使用频率报告</el-button>
                    <el-dialog title="上传文件" :visible.sync="dialogFormVisible_resource" width="600px" :destroy-on-close="true" :close-on-click-modal="false">
                        <upload ref="upload_file" :getRCResource="getRCResource" :task_id="task_id"></upload>
                        <div style="margin-top:-10px;">
                            <el-button @click="dialogCancel_resource">取 消</el-button>
                            <el-button type="primary" @click="uploadFile_resource">立即上传</el-button>
                        </div>
                    </el-dialog>
                </div>
            </div>
            <resour-mana ref="resour_mana" :resource_info="resource_info"></resour-mana>
        </el-tab-pane>
        <el-tab-pane label="调研设置" name="fifth">
            <cond-mana :task_id="task_id" :sys_params="sys_params"></cond-mana>
        </el-tab-pane>
        <el-tab-pane label="进度跟踪" name="sixth">
            <rc-progress :task_id="task_id"></rc-progress>
        </el-tab-pane>
    </el-tabs>
    </div>
</template>

<script>
import userMana from "./RC_usermana.vue";
import behavMana from "./RC_behavior.vue";
import motivMana from "./RC_motivation.vue";
import resourMana from "./RC_resource.vue";
import condMana from "./RC_condmana.vue";
import rcProgress from "../ProgressTracking/RC_progress.vue";

import upload from "../UpLoad.vue";
import getdata from "@/api/getData.js";
import postdata from "@/api/postData.js";
// import relationmana from "./ChengShu_relationmana.vue";
export default { 
    beforeCreate() {
        getdata.getList("checklogin")
            .then((resp) => {
            if(resp.data.usertype != 'admin'){
                this.$router.push({
                    name: 'notFound',
                });
            }
            })
            .catch(() => {
            this.$router.push({
                path: '/RClogin',
            });
            })       
    },
    created() {
        this.task_id = this.$route.query.taskid;
        this.getRCBehavior();
        // this.getRCMotivation();
        this.getRCResource();
        //this.getPainSpotSurvey();
        // this.getManaSurvey();
        this.getTaskName();
    },
    data() {
        return {
            activeName: 'first',
            dialogFormVisible_behavior: false,
            dialogFormVisible_motivation: false,
            dialogFormVisible_resource: false,
            behavior_info: [],
            motivation_info_props: [],
            resource_info: [],
            taks_name: '',
            mana_survey: false,
            task_id: null,
            results_file: {
                file_name: 'mana_survey_results.xlsx',
            },
            isUpdateProgress: false,
            load_user: true,    // 是否加载用户
            sys_params: {},
            motivation_maxnum_1: 5,
            motivation_maxnum_2: 6,
            motivation_maxnum_3: 5,
        }
    },
    components: {
        userMana,
        behavMana,
        motivMana,
        resourMana,
        condMana,
        upload,
        rcProgress,
    },
    methods: {
        download_behavior_template() {
            this.$refs.behav_mana.Download_template();
        },
        import_behavior_template() {
            this.dialogFormVisible_behavior = true;
        },
        export_behavior_report() {

        },
        download_motivation_template() {
            this.$refs.motiv_mana.Download_template();
        },
        import_motivation_template() {
            this.dialogFormVisible_motivation = true;
        },
        export_motivation_report() {

        },
        download_resource_template() {
            this.$refs.resour_mana.Download_template();
        },
        import_resource_template() {
            this.dialogFormVisible_resource = true;
        },
        export_resource_report() {

        },
        dialogCancel_behavior() {
            this.dialogFormVisible_behavior = false;
        },
        uploadFile_behavior() {
            this.$refs.upload_file.uploadFile('importRCBehavior');
            this.dialogFormVisible_behavior = false;
        },
        dialogCancel_motivation() {
            this.dialogFormVisible_motivation = false;
        },
        uploadFile_motivation() {
            this.$refs.upload_file.uploadFile('importRCMotivation');
            this.dialogFormVisible_motivation = false;
        },
        dialogCancel_resource() {
            this.dialogFormVisible_resource = false;
        },
        uploadFile_resource() {
            this.$refs.upload_file.uploadFile('importRCResource');
            this.dialogFormVisible_resource = false;
        },
        handleClick(tab) {
            if(tab.label=='名单设置'){
                if(this.load_user == true){
                    this.$refs.user_mana.getUserInfo();
                    this.load_user = false;
                }                   
            }else if(tab.label=='工作动机设置'){
                this.$refs.motiv_mana.getRCMotivation(this.task_id);
            }
            // console.log(tab, event);
        },
        Download_template() {
            this.$refs.ques_mana.Download_template();
        },
        Download_template_survey() {
            this.$refs.survey_mana.Download_template();
        },
        Import_question() {
            this.dialogFormVisible = true;
            // this.getManaQues();
        },
        Import_question_survey() {
            this.dialogFormVisible_survey = true;
        },
        dialogCancel() {
            this.dialogFormVisible = false;
        },
        dialogCancel_survey() {
            this.dialogFormVisible_survey = false;
        },
        uploadFile() {
            // 调用子组件的上传方法
            this.$refs.upload_file.uploadFile('importJKPainSpotSurvey');
            this.dialogFormVisible = false;
            // 这里不能直接使用getManaQues()方法加载已导入的问卷，得在子组件中调用父组件的该方法完成加载
            // this.getManaQues();
        },
        uploadFile_survey() {
            this.$refs.upload_file.uploadFile('importHealthSurvey');
            this.dialogFormVisible_survey = false;
        },
        // 获取RC行为问卷
        getRCBehavior() {
            let params = {
                task_id: this.task_id,
            }
            getdata.getListP("getRCBehavior", params)
            .then(resp => {
                if(resp.data.code == 200){
                    this.behavior_info = resp.data.data;
                }
            })
            .catch(err => {
                console.log(err);
            });
        }, 
        // 获取RC工作动机问卷     
        getRCMotivation() {
            this.$refs.motiv_mana.getRCMotivation(this.task_id);
            // let params = {
            //     task_id: this.task_id,
            // }
            // getdata.getListP("getRCMotivation", params)
            // .then(resp => {
            //     if(resp.data.code == 200){
            //         this.motivation_info_props = resp.data.data;
            //     }
            // })
            // .catch(err => {
            //     console.log(err);
            // });
        },
        // 获取RC激励资源问卷
        getRCResource() {
            let params = {
                task_id: this.task_id,
            }
            getdata.getListP("getRCResource", params)
            .then(resp => {
                if(resp.data.code == 200){
                    this.resource_info = resp.data.data;
                }
            })
            .catch(err => {
                console.log(err);
            });
        },
        getTaskName() {
            let params;
            params = {
                task_id: this.$route.query.taskid,
                type: 'RC',
            }
            getdata.getListP("getTaskName", params)
            .then(resp => {
                if(resp.data.code == 200){
                    this.taks_name = resp.data.task_name;
                }
            })
            .catch(err => {
                console.log(err);
            });
        },
        export_survey_results() {
            let params;
            params = {
                task_id: this.task_id,
            }
            postdata.downloadFilesP("exportSurveyResults", JSON.stringify(this.results_file), params)
            .then(resp => {               
                this.dialogFormVisible = false;
                // 将流文件通过浏览器下载，这里使用整个后台返回的response，供download函数提取data、headers等信息
                if(resp.data.type=='application/json'){
                    let that = this;    //这里要用别名替代this，因为FileReader里头可能也用到了this，两边有冲突
                    const reader  = new FileReader();  //创建一个FileReader实例
                    reader.readAsText(resp.data, 'utf-8'); //读取文件,结果用字符串形式表示
                    reader.onload=function(){   //读取完成后,**获取reader.result**
                        const msg = JSON.parse(reader.result);
                        that.$message({
                        message: msg.message,
                        type: 'error',
                        duration: 6000,
                        // showClose: true,
                        })
                    }
                }else{
                this.download(resp);
                }
            })
            .catch(err => {
                console.log(err);
            })
        },
        download (res) {
            let blob = new Blob([res.data], { type: "application/vnd.ms-excel" });//type是文件类，详情可以参阅blob文件类型
            // 创建新的URL并指向File对象或者Blob对象的地址
            const blobURL = window.URL.createObjectURL(blob)
            // 创建a标签，用于跳转至下载链接
            const tempLink = document.createElement('a')
            tempLink.style.display = 'none'
            tempLink.href = blobURL
            tempLink.setAttribute('download', decodeURI(res.headers['content-disposition'].split(';')[1].split('=')[1]))
            // 兼容：某些浏览器不支持HTML5的download属性
            if (typeof tempLink.download === 'undefined') {
                tempLink.setAttribute('target', '_blank')
            }
            // 挂载a标签
            document.body.appendChild(tempLink)
            tempLink.click()
            document.body.removeChild(tempLink)
            // 释放blob URL地址
            window.URL.revokeObjectURL(blobURL)
        },
    }
}
</script>

<style scoped>
.top_buttons > .el-button {
    font-size: 16px;
    /* font-weight: bold; */
}
::v-deep .el-tabs__item {
    font-size: 20px;
}
::v-deep .el-tabs__content {
    margin-top: 30px;
}
.el-breadcrumb {
    font-size: 20px;
    border-left: solid 6px #606266;
    padding-left: 15px;
    margin-bottom: 30px;
}
::v-deep .el-dialog__header {
    text-align: left;
}
</style>